import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const FavoryCommand = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="21"
      height="21"
      strokeWidth="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        vectorEffect="non-scaling-stroke"
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
        fill={props.checked ? props.color : "none"}
        stroke={props.color}
      />
    </svg>
  );
};

export default FavoryCommand;
